import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  resetForm,
  getCostCenterById,
  modifyCostCenter,
  modifyCustomField, //Groups
  addCostCenter,
  updateCostCenter,
} from 'cost_centers/actions';
import { getEditing } from 'cost_centers/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';
import { valueFromEvent, createRoute } from 'lib/util';
import { getCustomFieldsEmployees } from 'custom_fields_employees/actions'; //Groups
import { getGroups } from 'groups/actions'; //Groups

export class CostCentersFormHandlers extends Component {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false, isSaving: false };

  componentWillMount = () => {
    const { did } = this.props.match.params;
    this.props.reset();
    did && this.props.getById(did, this.props.company.id, this.props.subcompany.id);
    //Groups
    // console.log(this.props)
    this.props.getCustomFields(this.props.company.id, this.props.subcompany.id);
    const filters = { fulltext: 'centro_de_costos', columnSearch: ['module'] }; // Filtros para traer solo los grupos de empleados
    this.props.getGroups(this.props.company.id, this.props.subcompany.id, filters);
    //Groups
  };

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.costCenter.id
          ? this.props.update(
              this.props.costCenter.id,
              this.props.company.id,
              this.props.subcompany.id,
              this.props.costCenter
            )
          : this.props.add(this.props.company.id, this.props.subcompany.id, this.props.costCenter);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(
              createRoute(this.props.company.id, this.props.subcompany.id, 'cost_centers')
            );
          })
          .catch((err) => {
            this.finishSaving();
            this.props.error(err.message);
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving = () => this.setState({ isSaving: false });

  handleValueChange = (e) => this.props.modify(valueFromEvent(e));

  //Groups
  handleGroupChange = (e) => {
    const { value } = e.target;
    let _group = [{ _id: value }];
    if (value == 'null' || value == '' || value == null || value == undefined) _group = [];
    this.props.modify({ _group });
  };

  handleCustomFieldChange = (e) => this.props.modifyCustomField(valueFromEvent(e)); // Especial para custom fields
  //Groups

  sumar = (a, b) => {
    return a + b;
  };

  handleValidation = (isValid) => this.setState({ isValid });

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleAddYear: this.handleAddYear,
      handleRemoveYear: this.handleRemoveYear,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleCustomFieldChange: this.handleCustomFieldChange, //Groups
      handleGroupChange: this.handleGroupChange, //Groups
      handleValidation: this.handleValidation,
      sumar: this.sumar, // Prueba
    });
}

const mapStateToProps = (state) => ({
  costCenter: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

const mapDispatchToProps = {
  add: addCostCenter,
  error: addGrowlError,
  getById: getCostCenterById,
  modify: modifyCostCenter,
  getCustomFields: getCustomFieldsEmployees, //Groups
  getGroups: getGroups, //Groups
  modifyCustomField: modifyCustomField, //Groups
  reset: resetForm,
  success: addGrowlSuccess,
  update: updateCostCenter,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CostCentersFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/containers/CostCenterFormHandlers.js